export default __webpack_public_path__ + "static/media/bihorel5.849dc466.jpg";